var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsCt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-es-ct",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#da121a",
    strokeWidth: 60,
    d: "M0 90h810m0 120H0m0 120h810m0 120H0",
    transform: "scale(.79012 .88889)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsCt);
export default __webpack_public_path__ + "static/media/es-ct.ae2d1ab9.svg";
export { ForwardRef as ReactComponent };